window.ciBodyLoader = (function($) {
    function BodyLoader() {
        this.config = {
            id: 'ci-body-loader',
            parentEl: null,
            parentSelector: 'body',
            resizeToParent: false,
            timeout: 5000,
            message: '',
            imageSrc: '',
            innerTemplate: '<span class="h-100p w-100p flex-xyc absolute i-1"><img class="max-w-22" src="{{imageSrc}}" /></span>',
            bodyLock: true
        };
        this.state = {
            timeout: false,
            message: false
        };
        this.$loader = {};
    }
    
    BodyLoader.prototype.init = function(configObject) {
        var _ciBodyLoader = this;
        var config = _ciBodyLoader.config;
        
        if (typeof configObject === 'object') {
            $.extend(config, configObject);
        }  
        
        if ($('#' + config.id).length) {
            _ciBodyLoader.$loader = $('#' + config.id);
        } else {
            if (config.imageSrc) {
                config.innerTemplate = config.innerTemplate.replace('{{imageSrc}}', config.imageSrc);
            } else {
                config.innerTemplate = '';
            }          
            
            _ciBodyLoader.$loader = $(
                '<div id="' + config.id + '" class="ci-body-loader">' + 
                config.innerTemplate +
                    '<div class="ci-body-loader-message">' + config.message + '</div>' + 
                '</div>'
            );          

            if (config.parentEl) {
                _ciBodyLoader.$loader.prependTo(config.parentEl);
            } else {
                _ciBodyLoader.$loader.prependTo(config.parentSelector);
            }
            
            
            if (config.resizeToParent) {
                _ciBodyLoader.$loader.css({
                    width: '100%',
                    height: '100%',
                    position: 'absolute'
                });
            }
        }
    };
    
    BodyLoader.prototype.show = function() {
        var _ciBodyLoader = this;
        var timeout = _ciBodyLoader.state.timeout !== false ? _ciBodyLoader.state.timeout : _ciBodyLoader.config.timeout;
        
        if (_ciBodyLoader.config.bodyLock) {
            $('body').addClass('ci-body-loader-lock');
        }
        
        
        if (_ciBodyLoader.state.message !== false) {
            _ciBodyLoader.$loader.find('.ci-body-loader-message').text(_ciBodyLoader.state.message);
        }
        
        _ciBodyLoader.$loader.stop().fadeIn(200);
        
        setTimeout(function() { // for bfcache
            _ciBodyLoader.hide();
            _ciBodyLoader.state.timeout = false;
            _ciBodyLoader.state.message = false;
            _ciBodyLoader.$loader.find('.ci-body-loader-message').text(_ciBodyLoader.config.message);
        }, timeout);
    };
    
    BodyLoader.prototype.hide = function() {
        if (this.config.bodyLock) {
            $('body').removeClass('ci-body-loader-lock');
        }
        
        this.$loader.hide();
    };
    
    BodyLoader.prototype.setTimeoutOnce = function(timeout) {
        this.state.timeout = timeout;
    };
    
    BodyLoader.prototype.setMessageOnce = function(message) {
        this.state.message = message;
    };
    
    return BodyLoader;
}(jQuery));